'use client'

import React, {useState} from 'react'
import styles from './styles.module.css'
import TestimonialCardWithTags, {
  type TestimonialCardWithTagsProps,
} from '~/mercuryWebCompat/_components/TestimonialCardWithTags'
import TestimonialSlider from '~/mercuryWebCompat/_components/TestimonialSlider'
import TestimonialCarousel from '~/mercuryWebCompat/_components/TestimonialCarousel'
import sprigLogo from '~/mercuryWebCompat/_components/Templates/Testimonials/images/sprig-logo.png'
import qisstLogo from '~/mercuryWebCompat/_components/Templates/Testimonials/images/qisstpay-logo.png'
import monaLogo from '~/mercuryWebCompat/_components/Templates/Testimonials/images/mona-logo.png'

export default function Testimonials() {
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0)

  const testimonialCards = testimonialInfos.map(info => (
    // different layout than the <TestimonialCard /> component
    <TestimonialCardWithTags {...info} key={info.name} />
  ))

  return (
    <div className={styles.testimonialsWrapper}>
      <h3 className={styles.sectionTitle}>
        We help founders across industries, stages, and business types build
        companies that last
      </h3>
      <div className={styles.cardsWrapper}>
        <div className={styles.tablet}>
          <TestimonialSlider initialSlide={currentTestimonialIndex} infinite>
            {testimonialCards}
          </TestimonialSlider>
        </div>
        <div className={styles.desktop}>
          <TestimonialCarousel
            cards={testimonialCards}
            currentTestimonialIndex={currentTestimonialIndex}
            itemWidth={700}
            setCurrentTestimonialIndex={setCurrentTestimonialIndex}
            radius={400}
            tilt={15}
            initialSpin={currentTestimonialIndex ? 0 : 100}
          />
        </div>
      </div>
    </div>
  )
}

const testimonialInfos: TestimonialCardWithTagsProps[] = [
  {
    testimonialType: 'Stages',
    tags: ['Pre-seed', 'Series A', 'Other'],
    testimonial:
      'We’ve been with Mercury since the beginning, and while we’ve grown quickly, Mercury has grown with us. They’re just as useful with 90 million raised as they were at seed.',
    name: 'Ryan Glasgow',
    handle: 'CEO, Sprig',
    src: sprigLogo,
  },
  {
    testimonialType: 'Business Types',
    tags: ['Corporation', 'Nonprofit', 'LLC', 'Other'],
    testimonial:
      'Mercury gave us everything we needed to get started, from accounts to quick and easy global payments. As a founder having experienced dozens of interfaces, Mercury has one of the best in the industry.',
    name: 'Jordan Olivas',
    handle: 'CEO and co-founder, QisstPay',
    src: qisstLogo,
  },
  {
    testimonialType: 'Industries',
    tags: ['Tech', 'Web 3', 'Ecommerce', 'Other'],
    testimonial: `Mercury allows for sleek navigation, simple transfers without fees, quick note-taking to track expenses, and easy card distribution for your entire team. I'm so glad I made the switch to Mercury from a traditional bank.`,
    name: 'Andrew Leon Hanna',
    handle: 'Founder, Mona',
    src: monaLogo,
  },
]
